import React, { useState, useEffect } from 'react';
// Ajuste o import conforme sua estrutura real
import { TelemetriaApi, ConfiguracaoTelemetria } from '../../api/classes/TelemetriaApi';

// Hook para capturar combinação de teclas
const useTeclaAtalho = (combinacao: string, callback: () => void) => {
  useEffect(() => {
    const handleKeyDown = (evento: KeyboardEvent) => {
      // Ctrl + Shift + F12
      if (evento.ctrlKey && evento.shiftKey && evento.key === 'F12') {
        evento.preventDefault();
        callback();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [callback]);
};

export default function PopupTelemetria() {
  const [popupAberto, setPopupAberto] = useState(false);

  // Removido statusTelemetria (JSON) pois não será mais exibido visualmente
  const [configuracoes, setConfiguracoes] = useState<ConfiguracaoTelemetria>({
    desempenho: false,
    reentrancia: false,
    bloquearReentrancia: false,
    coverage: false,
  });

  const [carregando, setCarregando] = useState(false);
  const [mensagem, setMensagem] = useState('');

  // Modais de confirmação
  const [alertaBloqueio, setAlertaBloqueio] = useState(false);
  const [alertaFlush, setAlertaFlush] = useState(false); // Novo estado para confirmação de flush

  // Instância da API
  const api = new TelemetriaApi();

  // Ativar popup com Ctrl+Shift+F12
  useTeclaAtalho('ctrl+shift+F12', () => setPopupAberto(true));

  // Buscar status inicial ao abrir
  useEffect(() => {
    if (popupAberto) {
      obterStatus();
    }
  }, [popupAberto]);

  const obterStatus = async () => {
    try {
      setCarregando(true);

      // O 'dados' retorna da API. Como é 'any' em tempo de execução,
      // pode vir como PascalCase (C# padrão) ou camelCase.
      const dados: any = await api.obterStatus();

      if (dados) {
        // Mapeamento robusto: Verifica 'propriedade' OU 'Propriedade'
        // Isso garante que o checkbox marque independente da serialização do backend
        setConfiguracoes({
          desempenho: dados.desempenho ?? dados.Desempenho ?? false,
          reentrancia: dados.reentrancia ?? dados.Reentrancia ?? false,
          bloquearReentrancia: dados.bloquearReentrancia ?? dados.BloquearReentrancia ?? false,
          coverage: dados.coverage ?? dados.Coverage ?? false,
        });
      }
    } catch (erro: any) {
      exibirMensagem(`Erro ao obter status: ${erro.message || 'Erro desconhecido'}`, 'erro');
    } finally {
      setCarregando(false);
    }
  };

  const exibirMensagem = (texto: string, tipo = 'sucesso') => {
    setMensagem(texto);
    setTimeout(() => setMensagem(''), 3000);
  };

  const atualizarConfiguracao = (chave: keyof ConfiguracaoTelemetria, valor: boolean) => {
    if (chave === 'bloquearReentrancia' && valor === true) {
      setAlertaBloqueio(true);
    }

    setConfiguracoes(prev => ({
      ...prev,
      [chave]: valor,
    }));
  };

  const confirmarBloqueio = () => {
    setAlertaBloqueio(false);
  };

  const cancelarBloqueio = () => {
    setConfiguracoes(prev => ({
      ...prev,
      bloquearReentrancia: false,
    }));
    setAlertaBloqueio(false);
  };

  // --- Lógica para Descarregar Telemetria (Flush) ---
  const solicitarFlush = () => {
    setAlertaFlush(true);
  };

  const cancelarFlush = () => {
    setAlertaFlush(false);
  };

  const confirmarFlush = async () => {
    setAlertaFlush(false);
    try {
        setCarregando(true);
        // Requisito 2: Invocar método correspondente
        const sucesso = await api.descarregarTelemetria();
        if (sucesso) {
            exibirMensagem('Telemetria descarregada (flush) com sucesso!');
        } else {
            exibirMensagem('Falha ao descarregar telemetria.', 'erro');
        }
    } catch (erro: any) {
        exibirMensagem(`Erro ao descarregar: ${erro.message}`, 'erro');
    } finally {
        setCarregando(false);
    }
  };
  // --------------------------------------------------

  const aplicarConfiguracao = async () => {
    try {
      setCarregando(true);
      const sucesso = await api.configurarParametros(configuracoes);

      if (sucesso) {
        exibirMensagem('Configuração aplicada com sucesso');
        await obterStatus(); // Recarrega para garantir sincronia
      } else {
        exibirMensagem('Erro ao aplicar configuração', 'erro');
      }
    } catch (erro: any) {
      exibirMensagem(`Erro: ${erro.message || 'Falha na requisição'}`, 'erro');
    } finally {
      setCarregando(false);
    }
  };

  // const ativarTudo = () => {
  //   setConfiguracoes({
  //     desempenho: true,
  //     reentrancia: true,
  //     bloquearReentrancia: false,
  //     coverage: true,
  //   });
  //   exibirMensagem('Itens selecionados. Clique em OK para aplicar.');
  // };

  // const desativarTudo = () => {
  //   setConfiguracoes({
  //     desempenho: false,
  //     reentrancia: false,
  //     bloquearReentrancia: false,
  //     coverage: false,
  //   });
  //   exibirMensagem('Itens desmarcados. Clique em OK para aplicar.');
  // };

  // const verificarAtivacao = async () => {
  //   try {
  //     setCarregando(true);
  //     const ativa = await api.verificarAtivacao();

  //     exibirMensagem(
  //       `Telemetria: ${ativa ? 'ATIVA' : 'INATIVA'}`,
  //       ativa ? 'sucesso' : 'info'
  //     );
  //   } catch (erro: any) {
  //     exibirMensagem(`Erro na verificação: ${erro.message}`, 'erro');
  //   } finally {
  //     setCarregando(false);
  //   }
  // };

  const fecharPopup = () => {
    setPopupAberto(false);
    setMensagem('');
    setAlertaBloqueio(false);
    setAlertaFlush(false);
  };

  if (!popupAberto) return null;

  const estiloContainer: React.CSSProperties = {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  };

  const estiloPopup = {
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '28rem',
  };

  return (
    <div style={estiloContainer}>
      <div style={estiloPopup}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.5rem', borderBottom: '1px solid #e5e7eb' }}>
          <h2 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#1f2937' }}>
            Configuração de Telemetria
          </h2>
          <button onClick={fecharPopup} style={{ color: '#9ca3af', backgroundColor: 'transparent', border: 'none', cursor: carregando ? 'not-allowed' : 'pointer', fontSize: '1.5rem', padding: '0', opacity: carregando ? 0.5 : 1 }} disabled={carregando}>
            ✕
          </button>
        </div>

        {/* Conteúdo */}
        <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem', maxHeight: '26rem', overflowY: 'auto' }}>
          {mensagem && <div style={{ padding: '0.75rem', borderRadius: '0.25rem', fontSize: '0.875rem', backgroundColor: mensagem.includes('Erro') ? '#fee2e2' : '#dcfce7', color: mensagem.includes('Erro') ? '#b91c1c' : '#166534' }}>{mensagem}</div>}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer', opacity: carregando ? 0.5 : 1 }}>
              <input type="checkbox" checked={configuracoes.desempenho} onChange={(e) => atualizarConfiguracao('desempenho', e.target.checked)} disabled={carregando} style={{ width: '1rem', height: '1rem', cursor: 'pointer' }} />
              <span style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151' }}>Desempenho</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer', opacity: carregando ? 0.5 : 1 }}>
              <input type="checkbox" checked={configuracoes.reentrancia} onChange={(e) => atualizarConfiguracao('reentrancia', e.target.checked)} disabled={carregando} style={{ width: '1rem', height: '1rem', cursor: 'pointer' }} />
              <span style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151' }}>Reentrância</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer', opacity: carregando ? 0.5 : 1 }}>
              <input type="checkbox" checked={configuracoes.coverage} onChange={(e) => atualizarConfiguracao('coverage', e.target.checked)} disabled={carregando} style={{ width: '1rem', height: '1rem', cursor: 'pointer' }} />
              <span style={{ fontSize: '0.875rem', fontWeight: 500, color: '#374151' }}>Cobertura (Coverage)</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer', opacity: carregando ? 0.5 : 1 }}>
              <input type="checkbox" checked={configuracoes.bloquearReentrancia} onChange={(e) => atualizarConfiguracao('bloquearReentrancia', e.target.checked)} disabled={carregando} style={{ width: '1rem', height: '1rem', cursor: 'pointer' }} />
              <span style={{ fontSize: '0.875rem', fontWeight: 500, color: configuracoes.bloquearReentrancia ? '#dc2626' : '#374151' }}>Bloquear Reentrância</span>
            </label>
          </div>
          {/*
          { Botões de Ação }
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.5rem', paddingTop: '0.5rem' }}>
            <button onClick={ativarTudo} disabled={carregando} style={{ backgroundColor: '#22c55e', color: 'white', fontSize: '0.875rem', padding: '0.5rem', borderRadius: '0.25rem', border: 'none', cursor: carregando ? 'not-allowed' : 'pointer', opacity: carregando ? 0.5 : 1, fontWeight: 500 }}>Ativar Tudo</button>
            <button onClick={desativarTudo} disabled={carregando} style={{ backgroundColor: '#ef4444', color: 'white', fontSize: '0.875rem', padding: '0.5rem', borderRadius: '0.25rem', border: 'none', cursor: carregando ? 'not-allowed' : 'pointer', opacity: carregando ? 0.5 : 1, fontWeight: 500 }}>Desativar Tudo</button>
            <button onClick={verificarAtivacao} disabled={carregando} style={{ backgroundColor: '#3b82f6', color: 'white', fontSize: '0.875rem', padding: '0.5rem', borderRadius: '0.25rem', border: 'none', cursor: carregando ? 'not-allowed' : 'pointer', opacity: carregando ? 0.5 : 1, fontWeight: 500 }}>Verificar Status</button>

            { Requisito 2: Botão Flush }
            <button onClick={solicitarFlush} disabled={carregando} style={{ backgroundColor: '#f59e0b', color: 'white', fontSize: '0.875rem', padding: '0.5rem', borderRadius: '0.25rem', border: 'none', cursor: carregando ? 'not-allowed' : 'pointer', opacity: carregando ? 0.5 : 1, fontWeight: 500 }}>Forçar Flush</button>
          </div>
          */}
        </div>

        {/* Rodapé */}
        <div style={{ display: 'flex', gap: '0.75rem', padding: '1.5rem', borderTop: '1px solid #e5e7eb', backgroundColor: '#f9fafb' }}>
          <button onClick={aplicarConfiguracao} disabled={carregando} style={{ flex: 1, backgroundColor: carregando ? '#2563eb': '#22c55e', color: 'white', fontWeight: 500, padding: '0.5rem', borderRadius: '0.25rem', border: 'none', cursor: carregando ? 'not-allowed' : 'pointer', opacity: carregando ? 0.5 : 1 }}>{carregando ? 'Aplicando...' : 'Aplicar'}</button>
          <button onClick={solicitarFlush} disabled={carregando} style={{ flex: 1, backgroundColor: '#f59e0b', color: 'white', fontSize: '0.875rem', padding: '0.5rem', borderRadius: '0.25rem', border: 'none', cursor: carregando ? 'not-allowed' : 'pointer', opacity: carregando ? 0.5 : 1, fontWeight: 500 }}>Forçar Flush</button>
          <button onClick={fecharPopup} disabled={carregando} style={{ flex: 1, backgroundColor: '#ef4444', color: 'white', fontWeight: 500, padding: '0.5rem', borderRadius: '0.25rem', border: 'none', cursor: carregando ? 'not-allowed' : 'pointer', opacity: carregando ? 0.5 : 1 }}>Fechar</button>
        </div>
      </div>

      {/* Modal de Alerta - Bloqueio de Reentrância */}
      {alertaBloqueio && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }}>
          <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', maxWidth: '24rem', padding: '1.5rem' }}>
            <div style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#7c2d12', marginBottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>⚠️ Aviso de Produção</div>
            <div style={{ color: '#92400e', fontSize: '0.875rem', marginBottom: '1.5rem', lineHeight: '1.5' }}>
              <p style={{ marginBottom: '0.75rem' }}><strong>Não se recomenda ativar "Bloquear Reentrância" em ambiente de produção!</strong></p>
              <p>Essa configuração pode comprometer o processamento de orçamentos e causar travamentos do sistema. Use apenas em ambiente de desenvolvimento ou testes.</p>
            </div>
            <div style={{ display: 'flex', gap: '0.75rem' }}>
              <button onClick={cancelarBloqueio} style={{ flex: 1, backgroundColor: '#9ca3af', color: 'white', fontWeight: 500, padding: '0.5rem', borderRadius: '0.25rem', border: 'none', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={confirmarBloqueio} style={{ flex: 1, backgroundColor: '#dc2626', color: 'white', fontWeight: 500, padding: '0.5rem', borderRadius: '0.25rem', border: 'none', cursor: 'pointer' }}>Ativar mesmo assim</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Alerta - Flush */}
      {alertaFlush && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }}>
          <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', maxWidth: '24rem', padding: '1.5rem' }}>
            <div style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#b45309', marginBottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>🔄 Confirmar Flush</div>
            <div style={{ color: '#92400e', fontSize: '0.875rem', marginBottom: '1.5rem', lineHeight: '1.5' }}>
              <p>Deseja realmente forçar o descarregamento dos dados de telemetria agora? Isso pode impactar momentaneamente a performance.</p>
            </div>
            <div style={{ display: 'flex', gap: '0.75rem' }}>
              <button onClick={cancelarFlush} style={{ flex: 1, backgroundColor: '#9ca3af', color: 'white', fontWeight: 500, padding: '0.5rem', borderRadius: '0.25rem', border: 'none', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={confirmarFlush} style={{ flex: 1, backgroundColor: '#f59e0b', color: 'white', fontWeight: 500, padding: '0.5rem', borderRadius: '0.25rem', border: 'none', cursor: 'pointer' }}>Descarregar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}